let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 根据讲次查询课件 https://yapi.aixuexi.com/project/42/interface/api/197393
  getLessonCourseware: `${baseUrl}/courseware`
}
